export const TEXT_LIMITS = {
  chatMessage: 3000,
  supportText: 10000,
  shortText: 200,
  profileText: 2000,
  name: 120,
  filterText: 200,
};

export const countTextLength = (value) => {
  if (typeof value !== 'string') {
    return 0;
  }
  return Array.from(value).length;
};

export const isTextWithinLimit = (value, max) => countTextLength(value) <= max;
